import { FrontendSurfaceConfig } from '../types';

export const SURFACE_TENANT_VENDOR_PORTAL_USERS = 'tenant_vendor_portal_users';

export const tenantVendorPortalUsersSurface: FrontendSurfaceConfig = {
  surfaceKey: SURFACE_TENANT_VENDOR_PORTAL_USERS,
  searchPlaceholder: 'Search by email or name…',
  sortOptions: [
    { label: 'Email (A–Z)', value: 'va.email:asc' },
    { label: 'Email (Z–A)', value: 'va.email:desc' },
    { label: 'Name (A–Z)', value: 'va.name:asc' },
    { label: 'Last login (newest)', value: 'va.last_login_at:desc' },
    { label: 'Last login (oldest)', value: 'va.last_login_at:asc' },
    { label: 'Joined (newest)', value: 'va.created_at:desc' },
    { label: 'Joined (oldest)', value: 'va.created_at:asc' },
  ],
  filterOptions: [
    {
      key: 'vr.status',
      label: 'Status',
      options: [
        { label: 'Active', value: 'active' },
        { label: 'Disabled', value: 'disabled_by_tenant' },
        { label: 'Removed', value: 'removed' },
        { label: 'Lapsed', value: 'lapsed' },
      ],
    },
    {
      key: 'va.mfa_enabled',
      label: 'MFA',
      options: [
        { label: 'Enabled', value: 'true' },
        { label: 'Disabled', value: 'false' },
      ],
    },
  ],
  viewModes: [{ mode: 'table', label: 'Table', icon: 'list' }],
  defaultViewMode: 'table',
  defaultPageSize: 25,
};
